import { render, staticRenderFns } from "./Osgb.vue?vue&type=template&id=33746990&scoped=true"
import script from "./Osgb.vue?vue&type=script&lang=js"
export * from "./Osgb.vue?vue&type=script&lang=js"
import style0 from "./Osgb.vue?vue&type=style&index=0&id=33746990&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33746990",
  null
  
)

export default component.exports